import FormPrompt from './FormPrompt.tsx';
import ManagerPromptSettings from './ManagerPromptSettings.tsx';
import { useAtendabotLayout } from '../components/layout/Layout.tsx';

const PromptPage = () => {
  const layout = useAtendabotLayout();
  if (!layout?.promptSourceResolved) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center" role="status">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-indigo-200 border-t-indigo-600" />
        <span className="sr-only">Carregando configurações</span>
      </div>
    );
  }
  return layout.usesManagerPrompt ? <ManagerPromptSettings /> : <FormPrompt />;
};

export default PromptPage;
